import React from 'react';
import { CommonPrelanderV53 } from '../../components/CommonPrelanderV53';
import { QUIZ_SLIDES_V42 } from '../../shared/quiz-slides/quiz-slides-v42';

function PrelanderV59Page({ initialPrelander }) {
    return (
        <CommonPrelanderV53
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V42}
        />
    );
}

export {
    PrelanderV59Page
};
